import { render, staticRenderFns } from "./AIWarn.vue?vue&type=template&id=2e1ae4ad&scoped=true&"
import script from "./AIWarn.vue?vue&type=script&lang=js&"
export * from "./AIWarn.vue?vue&type=script&lang=js&"
import style0 from "./AIWarn.vue?vue&type=style&index=0&id=2e1ae4ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ae4ad",
  null
  
)

export default component.exports